import { ResourceCard } from '@components/common/resource-card';
import { SVGProps } from 'react';

interface Resource {
  title: string;
  description: Record<string, unknown> | undefined;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}
[];

interface Props {
  resources: Resource[];
  name: string;
}

export function Resources({ resources, name }: Props) {
  return (
    <div className="relative py-10">
      <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="text-base font-semibold uppercase tracking-wider text-clerk-blue">
          Get Started
        </h2>
        <h3 className="mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          Complete user management
        </h3>
        <p className="mx-auto mt-5 max-w-prose text-xl text-gray-500">
          Clerk is the ideal solution to{' '}
          <b className="font-normal">{name} authentication</b>. Integrate
          complete user management into your application quickly, without
          sacrificing security.
        </p>
        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {resources.map((resource: Resource) => {
              return <ResourceCard resource={resource} key={resource.title} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
